import React from 'react';
import { Notification } from '@progress/kendo-react-notification';

/** The warning above a section the application keeps locked: posted, or a refinance or side note worked in DealerFlow 360. */
const LockNotice = ({ message }: { message: string }) => (
  <Notification type={{ style: 'warning', icon: true }} style={{ width: '100%', marginBottom: 8 }}>
    {message}
  </Notification>
);

export default LockNotice;
